module.exports = __webpack_public_path__ + "img/IMG_9035.08849b20.jpg";